import * as React from 'react';
import { Header1, Image, Paragraph1 } from '@cian/ui-kit';
import { commercial, ICommercialTab } from '../../settings';
import { Commercial as CommercialComponent } from '../../components/Commercial';
import { CommercialTab } from '../../components/CommercialTab';
import { normalizeData, Typify } from '../../utils';

export function Commercial() {
  const [activeTab, setActiveTab] = React.useState(commercial.tabs[0].id);
  const preparedTabs = React.useMemo(() => commercial.tabs.map(tab => ({ title: tab.title, value: tab.id })), []);
  const normalizedTabs = React.useMemo(() => normalizeData<Typify<ICommercialTab>>(commercial.tabs), []);
  const currentTab = normalizedTabs.hash[activeTab];

  return (
    <CommercialComponent
      title={<Header1>{commercial.title}</Header1>}
      description={<Paragraph1>{commercial.description}</Paragraph1>}
      tabs={preparedTabs}
      activeTab={activeTab}
      onTabChange={setActiveTab}
      tabContent={
        <CommercialTab
          image={<Image src={currentTab.imgUrl} width={1100} height={595} />}
          description={<Paragraph1>{currentTab.description}</Paragraph1>}
        />
      }
    />
  );
}
